import api, { ApiResponse } from '@/clients/api';
import { JSONApiResponseBody } from './types/general/JSONApiResponse';
import { StampApiPostData } from './types/StampApi';

export async function postStampApi(
  url: string
): Promise<ApiResponse<200, JSONApiResponseBody<StampApiPostData[]>>> {
  return await api.post(url);
}
